"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var tv4 = require('tv4');

var Location = /*#__PURE__*/function () {
  function Location(opt) {
    _classCallCheck(this, Location);

    this.buildingId = '';
    this.floorId = '';
    this.roomId = '';
    this.sublocationId = '';
    this.buildingName = '';
    this.floorName = '';
    this.roomNumber = '';
    this.sublocationName = '';

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(Location, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.buildingId = opt.buildingId || '';
      this.floorId = opt.floorId || '';
      this.roomId = opt.roomId || '';
      this.sublocationId = opt.sublocationId || '';
      this.buildingName = opt.buildingName || '';
      this.floorName = opt.floorName || '';
      this.roomNumber = opt.roomNumber || '';
      this.sublocationName = opt.sublocationName || '';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Location.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'location.schema.json',
        type: 'object',
        properties: {
          buildingId: {
            type: 'string'
          },
          floorId: {
            type: 'string'
          },
          roomId: {
            type: 'string'
          },
          sublocationId: {
            type: ['string', 'null']
          },
          buildingName: {
            type: 'string'
          },
          floorName: {
            type: 'string'
          },
          roomNumber: {
            type: 'string'
          },
          sublocationName: {
            type: ['string', 'null']
          }
        },
        required: ['buildingId', 'floorId', 'roomId', 'sublocationId', 'buildingName', 'floorName', 'roomNumber', 'sublocationName']
      };
    }
  }]);

  return Location;
}();

module.exports = Location;